// extracted by mini-css-extract-plugin
export const inlineImage = "InlineImage-module--inline-image--1lOyP";
export const alignLeft = "InlineImage-module--align-left--2CEr4";
export const alignCenter = "InlineImage-module--align-center--FRuSS";
export const alignRight = "InlineImage-module--align-right--YOKsd";
export const widthQuarter = "InlineImage-module--width-quarter--17PBi";
export const widthThird = "InlineImage-module--width-third--X1MFR";
export const widthHalf = "InlineImage-module--width-half--2rBY3";
export const widthFull = "InlineImage-module--width-full--1TtMS";